import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { HrSubnav } from "./HrSubnav"
import { toast } from "sonner"

const API = API_BASE

export default function HrLeave() {
  const { t } = useTranslation()
  const [rows, setRows] = useState([])
  const [employees, setEmployees] = useState([])
  const [form, setForm] = useState({ employee_id: "", leave_type: "odihna", start_date: "", end_date: "", notes: "" })

  const load = () => {
    axios.get(`${API}/hr/leave`).then((r) => setRows(r.data)).catch(() => {})
    axios.get(`${API}/hr/employees`).then((r) => setEmployees(r.data)).catch(() => {})
  }

  useEffect(() => { load() }, [])

  const submit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${API}/hr/leave`, form)
      toast.success(t("app.hr.leave.toastRequested"))
      load()
    } catch {
      toast.error(t("app.hr.leave.toastError"))
    }
  }

  const approve = async (id) => {
    await axios.post(`${API}/hr/leave/${id}/approve`)
    toast.success(t("app.hr.leave.toastApproved"))
    load()
  }

  return (
    <AppLayout title={t("app.hr.leave.title")}>
      <HrSubnav />
      <form onSubmit={submit} className="rounded-xl border border-border p-4 mb-6 grid sm:grid-cols-2 gap-3 max-w-2xl">
        <div>
          <Label>Angajat</Label>
          <select className="w-full h-10 border rounded-md px-2 text-sm" required value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })}>
            <option value="">Selectează</option>
            {employees.map((e) => <option key={e.id} value={e.id}>{e.first_name} {e.last_name}</option>)}
          </select>
        </div>
        <div>
          <Label>Tip</Label>
          <select className="w-full h-10 border rounded-md px-2 text-sm" value={form.leave_type} onChange={(e) => setForm({ ...form, leave_type: e.target.value })}>
            <option value="odihna">Concediu odihnă</option>
            <option value="medical">Medical</option>
            <option value="maternitate">Maternitate</option>
          </select>
        </div>
        <div><Label>De la</Label><Input type="date" required value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} /></div>
        <div><Label>Până la</Label><Input type="date" required value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} /></div>
        <Button type="submit" className="sm:col-span-2">Adaugă cerere</Button>
      </form>
      <div className="rounded-xl border border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50"><tr><th className="p-3 text-left">Angajat</th><th className="p-3 text-left">Tip</th><th className="p-3 text-left">Perioadă</th><th className="p-3 text-left">Status</th><th /></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-border">
                <td className="p-3">{r.first_name} {r.last_name}</td>
                <td className="p-3">{r.leave_type}</td>
                <td className="p-3">{r.start_date?.slice(0, 10)} — {r.end_date?.slice(0, 10)}</td>
                <td className="p-3">{r.status}</td>
                <td className="p-3">{r.status === "pending" && <Button size="sm" variant="outline" onClick={() => approve(r.id)}>Aprobă</Button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  )
}
